/**
 * Возвращает первый дочерний элемент или узел указанного DOM-узла.
 * Поиск выполняется среди следующих свойств в указанной последовательности:
 * - `firstElementChild`
 * - `firstChild`
 * - `children`
 *
 * @param parent
 *      DOM-узел, для которого надо найти первый дочерний элемент или узел.
 * @return
 *      Найденный дочерний элемент/узел или `undefined`, если элемент/узел не найден.
 */
export function getFirstChild(parent: Node | undefined) {
    if (!parent) {
        return;
    }
    return (parent as Element).firstElementChild
        || parent.firstChild
        || ((parent as Element).children && (parent as Element).children[0]);
}
